import { lazy, Suspense } from 'react';

const MarkdownBlock = lazy(() => import('./MarkdownBlock'));

function MarkdownFallback({ text }) {
  if (!text) return null;

  return (
    <div className="markdown-block prose-pre:my-0 whitespace-pre-wrap break-words">
      {text}
    </div>
  );
}

export default function LazyMarkdownBlock({ text, ...props }) {
  if (!text) return null;

  return (
    <Suspense fallback={<MarkdownFallback text={text} />}>
      <MarkdownBlock text={text} {...props} />
    </Suspense>
  );
}
